<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/serviceHome/invitedList' }">我的报价</el-breadcrumb-item>
			  <el-breadcrumb-item>需求详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="container">
			<div class="leftsidebar">
				<div class="leftsidebarTitle">
					<h3>{{datails.name}}</h3>
					<p>发布时间：{{datails.create_time}}</p>
					<ul class="hangyeul">
						<li class="hangyeli"  v-for="(i) in datails.industries" :key="i">{{i}}</li>
					</ul>
				</div>
				<div class="leftsidebarDox">
					<div class="invitdatails">
						<h4>需求详情</h4>
						<p>{{datails.description}}</p>
					</div>
					<div class="invitimg">
						<div class="invitimg1">
							<h4>需求详情</h4>
							<div>
								<img v-for="(i,index) in  datails.file" :src="i" :key='index' />
							</div>
						</div>
						<div class="invitimg2">
							<h4>交付流程</h4>
							<div>
								<img  v-if="datails.confirm_image" :src="datails.confirm_image" alt="" srcset=""  />
								<img  v-if="datails.produce_image" :src="datails.produce_image" alt="" srcset=""  />
							</div>
						</div>
					</div>
				</div>
				
				<div class="leftsidebarDox">
					<h4>我的报价</h4>
					<div class="invitfrom">
						<ul class="invitTitle">
							<li style="width:278px;">我的信息</li>
							<li style="width:207px;">附件</li>
							<li style="width:150px;">报价金额</li>
							<li style="width:91px;">交付周期</li>
							<li style="width:128px;">报价状态</li>
						</ul>
						<ul class="invitUl" v-for="(i,index) in datails.quotes" :key="index">
							<li class="yaobiao1" style="width:278px;">
								<img :src="i.user.avatar" alt="" class="yaobiaotx">
								<div class="yaobiao1_1">
									<div class="yaobiao1_title">
										<p>{{i.user.nickname}}</p>
										<div v-if="i.is_invite==1">被邀标人</div>
									</div>
									<div class="yaobiao1_datails"> 
										<div>
											<img src="@/assets/caller.png" alt="" srcset="" />
											<span>{{i.user.display_score}}</span>
										</div>
										<span class="shu1">|</span>
										<div>
											<p>订单数量:</p>
											<span>{{i.user.total_order_num}}</span>
										</div>
										<span class="shu1">|</span>
										<div>
											<p>售后:</p>
											<span>{{i.user.aftersale_num}}</span>
										</div>
									</div>
									
								</div>
							</li>
							<li class="yaobiao2"  style="width:207px;">
								<img :src="i" alt="" srcset="" v-for="(i) in i.file" :key='i' />
								<img src="@/assets/kong.png" v-if="i.file.length==0" alt="" srcset="" />
							</li>
							<li class="yaobiao3" style="width:150px;">
								<span>￥{{i.price || 0.00}}</span>
							</li>
							<li class="yaobiao4" style="width:91px;">
								<span>{{i.period_format}}</span>
							</li>
							<li class="yaobiao5" style="width:128px;">
								<div v-if="datails.status==1">未报价</div>
								<div v-if="datails.status==2 && datails.is_select && i.price>0">已中标</div>
								<div v-if="datails.status==2 && !datails.is_select && i.price>0" style="background:#999;color:#fff;">未中标</div>
								<div v-if="datails.status==2 && i.price==0" style="background:#999;color:#fff;">未报价</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="rightsidebar">
				<div class="rightShenhe">
					<h3 class="datailsTop1_2" v-if="datails.status==1">报价中</h3>
					<h3 class="datailsTop1_2" v-if="datails.status==2">已结束</h3>
				</div>
				<div class="rightStype yaobiao1" >
					<img :src="datails.user.avatar" alt="" class="yaobiaotx">
					<div class="yaobiao1_1">
						<div class="yaobiao1_title" style="width:100%;display:inline-block;">
							<p style="width:100%;">{{datails.user.nickname}}</p>
							<div style="position: inherit;background: initial;display: flex;align-items: center;">
								<img src="@/assets/caller.png" alt="" srcset="" v-for="n in datails.user.display_score" :key="n" />
								<span>{{datails.user.display_score}}</span>
							</div>
						</div>
						<div class="yaobiao1_datails"> 
							<div>
								<p>订单数量:</p>
								<span>{{datails.user.total_order_num}}</span>
							</div>
							<span class="shu1">|</span>
							<div>
								<p>售后:</p>
								<span>{{datails.user.aftersale_num}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		DemandDetail,
		QuoteAdd,
		BaseGetConfig
	} from "@/api/api.js"
	import rightsidebarImg from '@/common/rightsidebarImg.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		rightsidebarImg  
	  },
	  data() {
	    return {
		    nametype:[
				{name:"承认图"},
				{name:"生产图"}
			],
			typeindex:0,
			datails:{
				name:"",
				create_time:"",
				industries:[],
				description:"",
				file:[],
				confirm_image:"",
				produce_image:"",
				status:0,
				is_select:false,
				quotes:[],
				user:{
					avatar:"",
					nickname:"",
					display_score:0,
					total_order_num:0,
					aftersale_num:0
				}
			},
			quote_file_config:""
	    }
	  },
	  computed:{
		  d_id() {
		    return this.$route.query.d_id || ''
		  }
	  },
	  mounted() {
	  	this.getDemandDetail()
		this.getBaseGetConfig()
	  },
	  methods: {
		getDemandDetail(){
			DemandDetail(this.d_id,{}).then(res=>{
				this.datails=res.data.data
			})
		},
		getBaseGetConfig(){
			BaseGetConfig({
				key:"quote_file_config"
			}).then(res=>{
				this.quote_file_config=res.data.data.quote_file_config
			})
		},
		qiehuan(index){
			this.typeindex=index
		}
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.container{
		width:1200px;
		margin: 0 auto;
		display:flex;
		justify-content:space-between;
	}
	.leftsidebar{
		width:894px;
	}
	.rightsidebar{
		width:282px;
	}
	.leftsidebarTitle{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.leftsidebarTitle p{
		font-weight: 400;
		font-size: 16px;
		color: #666666 !important;
	}
	.leftsidebarDox{
		width:100%;
		padding:20px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius:12px;
		margin-bottom:24px;
	}
	.hangyeul{
		width:100%;
		display:flex;
		flex-wrap:wrap;
	}
	.hangyeul::-webkit-scrollbar {
		  display: none;
	}
	.hangyeli{
		font-weight: 500;
		font-size: 14px;
		color: #4297FF;
		padding:2px 5px;
		box-sizing: border-box;
		margin-right:10px;
		margin-top:8px;
		background:#E3F0FF;
		border-radius: 4px 4px 4px 4px;
	}
	.invitdatails{
		width:100%;
	}
	.invitdatails p{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-top:12px;
	}
	.invitimg{
		width:100%;
		display:flex;
		justify-content:space-between;
		margin-top:24px;
	}
	.invitimg1 img{
		width:72px;
		height:72px;
		border-radius:6px;
		margin-right:16px;
	}
	.invitimg1 div,.invitimg2 div{
		margin-top:12px;
	}
	.invitimg2 img{
		width:72px;
		height:72px;
		border-radius:6px;
		margin-right:16px;
	}
	.invitfrom{
		width:100%;
		border:1px solid #D2D8E8;
		border-radius:12px;
		margin-top:20px;
	}
	.invitTitle{
		width:100%;
		display:flex;
		border-bottom:1px solid #D2D8E8;
	}
	.invitTitle li{
		text-align:left;
		line-height:52px;
		padding:0px 10px;
		box-sizing: border-box;
	}
	.invitUl{
		width:100%;
		display:flex;
	}
	.yaobiao1{
		padding:16px 12px;
		box-sizing: border-box;
		display:flex;
	}
	.yaobiaotx{
		width:32px;
		height:32px;
		border-radius:50%;
		margin-right:12px;
	}
	.yaobiao1_title{
		width:210px;
		position: relative;
	}
	.yaobiao1_title p{
		width:140px;
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.yaobiao1_title div{
		width: 58px;
		height: 20px;
		background: rgba(255,74,78,0.15);
		border-radius: 4px ;
		text-align:center;
		line-height:20px;
		font-weight: 500;
		font-size: 12px;
		color: #FF4A4E;
		position:absolute;
		right: 0;
		top: 0;
	}
	.yaobiao1_datails{
		display:flex;
		width:210px;
		margin-top:5px;
	}
	.yaobiao1_datails img{
		width:14px;
		height:14px;
		margin-right:5px;
	}
	.yaobiao1_datails p{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.yaobiao1_datails span{
		font-weight: 400;
		font-size: 12px;
		color: #333333;
	}
	.yaobiao1_datails div{
		display:flex;
		align-items: center;
		padding: 0px 10px 0px 0px;
		box-sizing: border-box;
	}
	.shu1{
		font-size:10px;
		margin-right:10px;
	}
	.yaobiao2,.yaobiao3,.yaobiao4,.yaobiao5{
		display:flex;
		align-items: center;
		padding:16px 12px;
		box-sizing: border-box;
	}
	.yaobiao2 img{
		width:42px;
		height:42px;
		border-radius:8px;
		margin-right:5px;
	}
	.yaobiao3{
		font-weight: bold;
		font-size: 24px;
		color: #FF5900;
	}
	.yaobiao4{
		font-weight: 400;
		font-size: 16px;
		color: rgba(51,51,51,0.9);
	}
	.yaobiao5 div{
		width: 80px;
		height: 32px;
		background: #1E3A8A;
		border-radius: 8px ;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.rightShenhe{
		width: 282px;
		height: 133px;
		background: #FFFFFF;
		border-radius: 12px ;
		display:flex;
		flex-direction: column;
		justify-content:center;
		align-items: center;
	}
	.rightShenhe h3{
		font-weight: bold;
		font-size: 24px;
		color: #E7AA00;
	}
	.rightShenhe p{
		font-weight: 500;
		font-size: 16px;
		color: #999999;
	}
	.rightStype{
		width: 282px;
		background: #FFFFFF;
		border-radius: 12px ;
		margin-top:24px;
	}
	.yaobiao1_title div{
		/* width:100%;
		display:flex;
		align-items:center; */
	}
	.yaobiao1_title div>img{
		width:14px;
		height:14px;
		margin-right:2px;
	}
	

</style>